import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from "./components/Navbar";
import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import SolutionsMDR from './pages/SolutionsMDR';
import TechReselling from './pages/TechReselling';
import Tactical from './pages/Tactical';
import Careers from './pages/Careers';
import CompanyInfo from './pages/CompanyInfo';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import CertificateVerify from './pages/CertificateVerify';

export default function App() {
  const adminSecretPath = "portal-gate-001";
  return (
    <Router>

      <Navbar />
      <Layout>
        <Routes>
          {/* Landing Page */}
          <Route path="/" element={<Home />} />          
          {/* MDR Solutions Page */}
          <Route path="/solutions-mdr" element={<SolutionsMDR />} />
          {/* Tech Reselling Page */}
          <Route path="/tech-reselling" element={<TechReselling />} />

          <Route path="/Tactical" element={<Tactical />} />

          <Route path="/Careers" element={<Careers />} />

          <Route path="/CompanyInfo" element={<CompanyInfo />} />

          <Route path="/verify/:certificateNumber" element={<CertificateVerify />} />

          <Route path="/AdminLogin" element={<AdminLogin />} />
          <Route path={`/${adminSecretPath}/dashboard`} element={<AdminDashboard />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </Router>
  );
}